import type { CoverageDto } from '../../../../../types';

interface InsuredInfo {
  companyName: string;
  address1: string;
  address2?: string;
  city: string;
  zipCode: string;
}

export const determineIfInsuredInformationDelta = (
  policy: InsuredInfo,
  endorsement: InsuredInfo
) => {
  return (
    policy.companyName !== endorsement.companyName ||
    policy.address1 !== endorsement.address1 ||
    policy.address2 !== endorsement.address2 ||
    policy.city !== endorsement.city ||
    policy.zipCode !== endorsement.zipCode
  );
};

interface CoverageInfo {
  endorsement: {
    aggLimit: number;
    coverages: CoverageDto[];
    deductible: number;
    hasTria: boolean;
    retroactivePeriod: number;
    waitingPeriod: number;
  };
}

export const composeEndorsementCoverageInfo = ({
  endorsement,
}: CoverageInfo) => {
  return {
    aggregateLimit: endorsement.aggLimit,
    coverages: endorsement.coverages,
    deductible: endorsement.deductible,
    hasTria: endorsement.hasTria,
    retroactivePeriod: endorsement.retroactivePeriod,
    waitingPeriod: endorsement.waitingPeriod,
  };
};

export const composeEndorsementInsuredInfo = ({ endorsement }: any) => {
  return {
    companyName: endorsement?.companyName,
    address1: endorsement?.firmographicData?.address1,
    address2: endorsement?.firmographicData?.address2,
    city: endorsement?.firmographicData?.city,
    zipCode: endorsement?.firmographicData?.zipCode,
  };
};
